import {getUsers, getUser, getUsersWithRole} from "@/api/users";
import { getPassengers } from "@/api/passengers";

const getDefaultState = () => {
  return {
    activeUser: {},

    users: [],
    admins: [],
    passengers: [],
    leaders: [],
    OSRstaff: [],
    logisticians: [],

    pagination: {
      pageList: {
        active: false,
        pages: []
      },
      currentPage: 1,
      lastPage: 0
    },

    activeUserLoading: true,
    usersLoading: true,
    rolesLoading: true,
    passengersLoading: true,
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    getActiveUser({ commit }, id) {
      commit("SET_ACTIVE_USER_LOADING", true);

      getUser(id)
        .then(({ data }) => {
          commit("SET_ACTIVE_USER", data);
        })
        .finally(() => {
          commit("SET_ACTIVE_USER_LOADING", false);
        });
    },
    getUsers({ commit, state }, params, perPage= 10, currentPage = 1) {
      const sort = params?.sort || ""
      const search = params?.search || ""
      const trashed = params?.trashed
      commit("SET_USERS_LOADING", true);
      currentPage = state.pagination.currentPage
      getUsers(perPage, currentPage, sort, search, trashed).then(res => {
          const data = res.data.data
          const users = [];
          const admins = [];
          const leaders = [];
          const OSRstaff = [];
          const logisticians = [];

          data.forEach((user) => {
            user.roles?.forEach((role) => {
              switch (role.id) {
                case 1:
                  admins.push(user);
                  break;
                case 2:
                  users.push(user);
                  break;
                case 3:
                  leaders.push(user);
                  break;
                case 4:
                  OSRstaff.push(user);
                  break;
                case 5:
                  logisticians.push(user);
              }
            });
          });

          commit("SET_USERS", data);
          commit("SET_ADMINS", admins);
          commit("SET_LEADERS", leaders);
          commit("SET_OSR_STAFF", OSRstaff);
          commit("SET_LOGISTICIANS", logisticians);
          commit("SET_USERS_LIST_PAGINATION", res.headers)
        })
        .finally(() => commit("SET_USERS_LOADING", false));
    },

    getUsersWithRole({ commit, state }, params, perPage= 10, currentPage = 1) {
      const role = params.role
      const sort = params.sort
      const search = params.search
      const trashed = params?.trashed || null
      commit("SET_ROLES_LOADING", true);
      currentPage = state.pagination.currentPage
      getUsersWithRole(role, perPage, currentPage, sort, search, trashed).then(res => {
        const data = res.data.data
        if (role === 1) {
          commit("SET_ADMINS", data);
        } else if (role === 4) {
          commit("SET_OSR_STAFF", data);
        }  else if (role === 5) {
          commit("SET_LOGISTICIANS", data);
        }
        commit("SET_USERS_LIST_PAGINATION", res.headers)
      }).finally(() => commit("SET_ROLES_LOADING", false));
    },

    // pagination
    getUsersListPage ({ commit, dispatch }, params) {
      commit('SET_CURRENT_PAGE', params.page)
      dispatch('getUsers', params)
    },

    getUsersRolesListPage ({ commit, dispatch }, params) {
      commit('SET_CURRENT_PAGE', params.page)
      dispatch('getUsersWithRole', params)
    },


    getPassengers({ commit , state }, params, perPage= 10, currentPage = 1) {
      const sort = params?.sort || ""
      const search = params?.search || ""
      commit("SET_PASSENGERS_LOADING", true);
      currentPage = state.pagination.currentPage
      getPassengers(perPage, currentPage, sort, search).then(res => {
          commit("SET_PASSENGERS", res.data)
          // commit("SET_PASSENGERS_LIST_PAGINATION", res.headers)
        }).finally(() => commit("SET_PASSENGERS_LOADING", false))
    },

    // pagination
    getPassengersListPage ({ commit, dispatch }, params) {
      commit('SET_CURRENT_PAGE', params.page)
      dispatch('getPassengers', params)
    },

    clearData({ commit }) {
      commit("INIT_STATE");
    },
  },
  mutations: {
    SET_ACTIVE_USER(state, user) {
      state.activeUser = user;
    },
    SET_USERS(state, users) {
      state.users = users;
    },
    SET_ADMINS(state, admins) {
      state.admins = admins;
    },
    SET_LEADERS(state, leaders) {
      state.leaders = leaders;
    },
    SET_OSR_STAFF(state, OSRstaff) {
      state.OSRstaff = OSRstaff;
    },
    SET_LOGISTICIANS(state, logisticians) {
      state.logisticians = logisticians;
    },
    SET_PASSENGERS(state, passengers) {
      state.passengers = passengers;
    },
    ADD_USER(state, user) {
      state.users.push(user);
    },
    ADD_PASSENGER(state, passenger) {
      state.passengers.push(passenger);
    },
    SET_ACTIVE_USER_LOADING(state, loading) {
      state.activeUserLoading = loading;
    },
    SET_USERS_LOADING(state, loading) {
      state.usersLoading = loading;
    },
    SET_ROLES_LOADING(state, loading) {
      state.rolesLoading = loading;
    },
    SET_PASSENGERS_LOADING(state, loading) {
      state.passengersLoading = loading;
    },
    INIT_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    // pagination
    SET_USERS_LIST_PAGINATION: (state, headers) => {
      state.pagination.currentPage = Number(headers['x-pagination-current-page'])
      state.pagination.lastPage = Number(headers['x-pagination-page-count'])
      // заполняем массив номерами страниц от 1 до последней страницы
      state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
    },
    RESET_USERS_LIST_CURRENT_PAGE: (state) => {
      state.pagination.currentPage = 1
    },
    SET_CURRENT_PAGE: (state, pageNum) => {
      state.pagination.currentPage = pageNum
    },

    // SET_PASSENGERS_LIST_PAGINATION: (state, headers) => {
    //   state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    //   state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    //   // заполняем массив номерами страниц от 1 до последней страницы
    //   state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
    // },

  },
  getters: {
    getUsersListPagination: state => state.pagination,
    // getPassengersListPagination: state => state.pagination,

    activeUserRole({ activeUser }) {
      const { roles } = activeUser;

      if (roles) {
        if (roles.some(({ id }) => id === 1)) return "Администратор";
        if (roles.some(({ id }) => id === 5)) return "Логист";
        if (roles.some(({ id }) => id === 3)) {
          return "Руководитель подразделения";
        }
        if (roles.some(({ id }) => id === 4)) return "Сотрудник ОСР";
        return "Пользователь";
      }

      return "-";
    },
    getUsers({ users }) {
      return users
    },
    isAdmin({ activeUser }) {
      return activeUser?.roles?.some(({ id }) => id === 1);
    },
    isLeader({ activeUser }) {
      return activeUser?.roles?.some(({ id }) => id === 3);
    },
    isOSRStaff({ activeUser }) {
      return activeUser?.roles?.some(({ id }) => id === 4);
    },
    isLogist({ activeUser }) {
      return activeUser?.roles?.some(({ id }) => id === 5);
    },
    isSuperAdmin({ activeUser }) {
      return activeUser?.roles?.some(({ id }) => id === 6);
    },
    userAvatarColor() {
      return (roles) => {
        if (roles) {
          if (roles.some(({ id }) => id === 1)) return "#FF0000";
          if (roles.some(({ id }) => id === 5)) return "#F9A825";
          if (roles.some(({ id }) => id === 3)) return "#8E7EB7";
          if (roles.some(({ id }) => id === 4)) return "#24C38E";
          if (roles.some(({ id }) => id === 6)) return "#FF0000";
        }
        return "#2196F3";
      };
    },
    usersWithFIO({ users }) {
       return users
          .filter(user => user.deleted_at === null)
          .map((user) => {
          return {
            FIO: `${user.surname || ""} ${user.name || ""} ${
              user.patronymic || ""
            }`,
            ...user,
          };
      });
    },
    usersByRoleWithFIO(state) {
      return (role = "users") => {
        return state[role].map((user) => {
          return {
            FIO: `${user.surname || ""} ${user.name || ""} ${
              user.patronymic || ""
            }`,
            ...user,
          };
        });
      };
    },
    passengersWithFIO( { passengers }) {
      return passengers.map((passenger) => {
          return {
            FIO: `${passenger.surname || ""} ${passenger.name || ""} ${
              passenger.patronymic || ""
            }`,
            ...passenger,
          };
      });
    }
  },
};
